.conferenceButtonRoot {
    border-radius: 0px;
    &[data-variant="transparent"] {
        &:hover {
            background-color: var(--exwo-color-control-bar-bg);
        }
        &:active {
            background-color: var(--exwo-color-control-bar-bg);
        }
    }
}

.conferenceButtonSection {
    margin-left: 0.1rem;
}
